import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { ONLINE_CHECK_IN } from '../../products';
import MainOnlineCheckIn from './MainOnlineCheckIn';
import SmallOnlineCheckIn from './SmallOnlineCheckIn';
import { jsx as _jsx } from "react/jsx-runtime";
const OnlineCheckIn = props => {
  switch (props.layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallOnlineCheckIn, {
        ...props
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainOnlineCheckIn, {
        ...props
      });
  }
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    isSelected: getSelected(ONLINE_CHECK_IN.name, form)(state)
  };
};
export default connect(mapStateToProps)(OnlineCheckIn);
//# sourceMappingURL=OnlineCheckIn.js.map